import { render, staticRenderFns } from "./RiskAssessment.vue?vue&type=template&id=13169769&scoped=true"
import script from "./RiskAssessment.vue?vue&type=script&lang=js"
export * from "./RiskAssessment.vue?vue&type=script&lang=js"
import style0 from "./RiskAssessment.vue?vue&type=style&index=0&id=13169769&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13169769",
  null
  
)

export default component.exports